/*eslint-disable */
import axios from 'axios';
import root from '../_helpers/roots';
let userVerfiedLinkUrl = root.userVerfiedLink.link
let forgotPwLink = root.forgotPwLink.link
let mblVerifyURL = root.mblVerifyUrl.link
let addMblVerifyURL = root.addMblVerifyUrl.link
export default ({
  state: {
    userVerifiedState: {},
    forogotpasswordState: {},
    resetPasswordState: {}
  },
  mutations: {
    userVerifiedMutation(state, response) {
      state.userVerifiedState = response
    },
    forogotPasswordMutation(state, response) {
      state.forogotpasswordState = response
    },
    resetPasswordMutation(state, response) {
      state.resetPasswordState = response
    }
  },
  actions: {
    getUserVerifiedFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(userVerfiedLinkUrl + payload.id)
          .then((resp) => {
            context.commit('userVerifiedMutation', resp.data)
            console.log(resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    forgotPasswordFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(forgotPwLink, payload)
          .then((resp) => {
            context.commit('forogotPasswordMutation', resp.data)
            console.log(resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    resetPasswordConfirmFun(context, payload) {
      return new Promise((resolve, reject) => {
        console.log(payload.id)
        //debugger
        axios.put(forgotPwLink + payload.data.id + '/', payload.data.data)
          .then((resp) => {
            context.commit('resetPasswordMutation', resp.data)
            console.log(resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    newUserMblNoVerifiedFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(mblVerifyURL, payload)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    newUserMblNoAddFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(addMblVerifyURL, payload)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  },
  getters: {
    getUserVerifiedState: state => state.userVerifiedState,
    getForogotpasswordState: state => state.forogotpasswordState,
    getResetPasswordState: state => state.resetPasswordState
  }
})